import React, { useState, useEffect } from "react";
import languageOptions from "./data/languageOptions.json";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft, FaSearch } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";

const LanguagesComponent = ({ user }) => {
  const [mainLanguages, setMainLanguages] = useState(
    languageOptions.languages.map((language) => ({
      text: language,
      isSelected: false,
    }))
  );

  const [otherLanguages, setOtherLanguages] = useState(
    languageOptions.languages.map((language) => ({
      text: language,
      isSelected: false,
    }))
  );

  const [validationError, setValidationError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const { isSmallScreen, handleBackClick } = useOutletContext();
  const baseURL = config.API_BASE_URL;

  useEffect(() => {
    if (user && user.id) {
      const fetchLanguages = async () => {
        try {
          const response = await axios.get(
            `${baseURL}/v1/worker-users/${user.id}`
          );
          const userData = response.data;
          const {
            mainLanguages: userMainLanguages,
            otherLanguages: userOtherLanguages,
          } = userData.languages || { mainLanguages: [], otherLanguages: [] };

          const updatedMainLanguages = mainLanguages.map((language) => ({
            ...language,
            isSelected: userMainLanguages.includes(language.text),
          }));

          const updatedOtherLanguages = otherLanguages.map((language) => ({
            ...language,
            isSelected: userOtherLanguages.includes(language.text),
          }));

          setMainLanguages(updatedMainLanguages);
          setOtherLanguages(updatedOtherLanguages);
        } catch (error) {
          console.error("Failed to fetch language data:", error);
        }
      };

      fetchLanguages();
    }
  }, [user, baseURL]);

  const toggleMainLanguageSelection = (index) => {
    const newLanguages = [...mainLanguages];
    newLanguages[index].isSelected = !newLanguages[index].isSelected;

    console.log(
      `Main Language: ${newLanguages[index].text} ${newLanguages[index].isSelected ? "Selected" : "Deselected"
      }`
    );

    setMainLanguages(newLanguages);
    setValidationError("");
  };

  const toggleOtherLanguageSelection = (index) => {
    const newLanguages = [...otherLanguages];
    newLanguages[index].isSelected = !newLanguages[index].isSelected;

    console.log(
      `Other Language: ${newLanguages[index].text} ${newLanguages[index].isSelected ? "Selected" : "Deselected"
      }`
    );

    setOtherLanguages(newLanguages);
    setValidationError("");
  };


  const handleSave = async () => {
    setValidationError("");

    const isAnyLanguageSelected =
      mainLanguages.some((language) => language.isSelected) ||
      otherLanguages.some((language) => language.isSelected);

    if (!isAnyLanguageSelected) {
      setValidationError("Please select at least one language.");
      return;
    }

    const selectedMainLanguages = mainLanguages
      .filter((language) => language.isSelected)
      .map((language) => language.text);

    const selectedOtherLanguages = otherLanguages
      .filter((language) => language.isSelected)
      .map((language) => language.text);

    const languageData = {
      languages: {
        mainLanguages: selectedMainLanguages,
        otherLanguages: selectedOtherLanguages,
      },
    };

    console.log("Selected languages for Patching:", languageData);

    try {
      const response = await axios.patch(
        `${baseURL}/v1/worker-users/${user.id}`,
        languageData
      );
      if (response.data) {
        console.log("Patch successful");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Failed to update language selections", error);
    }
  };

  return (
    <div className="languages-custom-component-container">
      {showModal && <SuccessModal />}
      <div className="language-indicative-above-div">
      <div className="profile-back-container">
        {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon"/> 
            </div>
          )}
          <h2>Conversational language(s)</h2>
        </div>
        
      </div>
      <div className="language-input-wrapper">
      <FaSearch className="language-search-icon" />
        <input
          type="text"
          className="language-search-input"
          placeholder="Search languages..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        /></div>

      <div className="language-buttons-container">
        {mainLanguages
          .filter((language) =>
            language.text.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((language, index) => (
            <button
              key={language.text}
              className={`language-horizontal-button ${language.isSelected ? "selected" : ""
                }`}
              onClick={() => toggleMainLanguageSelection(index)}
            >
              <div className="button-checkmark">
                {language.isSelected ? "✓" : ""}
              </div>
              <div className="button-text">{language.text}</div>
            </button>
          ))}
      </div>
      {validationError && (
        <div className="language-error">{validationError}</div>
      )}
      <div className="language-save">
        <button onClick={handleSave}>Save and continue</button>
      </div>
    </div>
  );
};

export default LanguagesComponent;
